import * as React from "react";
import LayerForFutureFuc from "map/layers/LayerForFutureFuc";
import LayerForFutureFucMarker from "map/layers/LayerForFutureFucMarker";
import LayerForFutureFucMarkerHall from "map/layers/LayerForFutureFucMarkerHall";
import "ol/ol.css";
import { fromLonLat } from "ol/proj";
import { getDarkTileLayers, getView } from "../../map/OlExtension";
import { Map as OlMap, Feature } from "ol";

// 대시보드 
export function FutureFucDash() {
    const divRef = React.useRef(null);
    const mapObjRefs = React.useRef(null);
    const intervalRef = React.useRef(null);

    React.useEffect(() => {
        if (divRef.current) {
            const map = new OlMap({
                target: divRef.current,
                view: getView(16.45, fromLonLat([127.055380, 37.291671])),
                controls: [],
                interactions: [], 
            });

            const linkLayer = new LayerForFutureFuc(map);
            const markerLayer = new LayerForFutureFucMarker(map);
            const markerHallLayer = new LayerForFutureFucMarkerHall(map);
            markerLayer.setZIndex(20);
            markerHallLayer.setZIndex(10);
            mapObjRefs.current = {
                map,
                linkLayer,
                markerLayer,
                markerHallLayer,
            };

            intervalRef.current = setInterval(() => {
                const { markerLayer } = mapObjRefs.current;

                if (markerLayer?.updatePositions) {
                    markerLayer.updatePositions(); // 5개 차량 위치 업데이트
                }
            }, 2000);

            return () => {
                clearInterval(intervalRef.current);
                map.setTarget(undefined);
            };
        }
    }, []);

    return <div ref={divRef} style={{ width: "100%", height: "100%" }} />;
}

// 통합관제 모듈
export function FutureFucModule() {
    const divRef = React.useRef(null); // 지도 영역
    const mapObjRefs = React.useRef(null);
    const intervalRef = React.useRef(null);

    React.useEffect(() => {
        if (divRef.current) {
            const map = new OlMap({
                target: divRef.current,
                // view: getView(16.0, fromLonLat([127.056000, 37.290171])),
                view: getView(16.0, fromLonLat([127.056000, 37.289571])),
                controls: [],
                interactions: [], 
            });

            mapObjRefs.current = {
                map,
                linkLayer: new LayerForFutureFuc(map),
                
                markerHallLayer: new LayerForFutureFucMarkerHall(map),
                markerLayer: new LayerForFutureFucMarker(map),
            }

            intervalRef.current = setInterval(() => {
                const { markerLayer } = mapObjRefs.current;

                if (markerLayer?.updatePositions) {
                    markerLayer.updatePositions(); // 5개 차량 위치 업데이트
                }
            }, 2000);

            return () => {
                map.setTarget(undefined);
            }
        }
    }, [divRef]);

    return (
        <React.Fragment>
            <div ref={divRef} style={{ width: "100%", height: "100%" }}/>
        </React.Fragment>
    );
}

